module.exports = __webpack_public_path__ + "img/88ne.314c2120.svg";